module.exports = __webpack_public_path__ + "assets/e1211aa935d544d78e381bed25e76555.jpg";